import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full h-32 md:h-40 flex rounded-lg border border-gray-300 mt-4 relative" }
const _hoisted_2 = { class: "h-32 w-32 md:h-40 md:w-40 flex-none items-center flex p-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "p-2 w-full text-left" }
const _hoisted_5 = { class: "h-10 md:h-16 text-sm md:text-base lg:text-lg flex items-center" }
const _hoisted_6 = { class: "multiple-truncate" }
const _hoisted_7 = { class: "font-bold my-1 md:text-lg" }
const _hoisted_8 = { class: "font-normal text-sm md:text-base ml-1" }
const _hoisted_9 = { class: "mx-auto" }
const _hoisted_10 = {
  key: 0,
  class: "absolute w-full h-full bg-gray-400 opacity-75"
}
const _hoisted_11 = {
  key: 1,
  class: "absolute w-full h-full flex"
}
const _hoisted_12 = { class: "bg-gray-200 text-gray-700 rounded-full m-auto text-sm py-2 px-4" }
const _hoisted_13 = { class: "text-2xs text-gray-700 mb-4 mt-1" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "text-sm my-3 sm:mx-16 text-left" }
const _hoisted_16 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.exchangeConfig.prize_option.image_path,
          alt: "giftImage",
          class: "object-contain flex justify-center"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.exchangeConfig.prize_option.title), 1)
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.needPointLabel), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.formattedConsumptionPoint), 1)
        ]),
        _createVNode(_component_BaseButton, {
          class: "p-2 w-full md:text-lg",
          buttonClass: "main",
          onClick: _ctx.handleExchangeClick,
          disabled: !_ctx.exchangeable
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.exchangeButtonLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      (!_ctx.exchangeable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.exchangeErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.exchangeErrorMessage), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.exchangePeriodLabel) + ": " + _toDisplayString(_ctx.exchangeConfig.exchangeable_period_option.exchangeable_begin_at) + "~" + _toDisplayString(_ctx.exchangeConfig.exchangeable_period_option.exchangeable_end_at), 1),
    _createVNode(_component_BaseModal, {
      open: _ctx.isModalOpen,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.exchangeConfig.prize_option.image_path,
          alt: "giftImage",
          class: "object-contain w-40 mx-auto my-2"
        }, null, 8, _hoisted_14),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", null, _toDisplayString(_ctx.confirmModalMessage), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_BaseButton, {
            class: "border mr-3 p-2 md:text-lg",
            onClick: _ctx.handleExchangeCancelClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.confirmModalCancelButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_BaseButton, {
            class: "py-2 px-8 md:text-lg",
            buttonClass: "main",
            onClick: _ctx.handleExchangeConfirmClick,
            disabled: !_ctx.exchangeable
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.confirmModalOkButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}